/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Components
import Accordion from 'shared/ui/components/Accordion.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import GenericDocExternalPicker from 'shared/ui/components/form-components/pickers/GenericDocExternalPicker.vue';
import ResetSessionCheckInData from './ResetSessionCheckInData.vue';
import StringsArrayInput from 'shared/ui/components/form-components/StringsArrayInput.vue';
import Toggler from 'shared/ui/components/form-components/Toggler.vue';

// Constants
import { SESSION_CHECK_IN_METADATA_FIELDS } from 'libs/utils/constants';

// Mixins
import saveSettings from 'ui/mixins/workspaces/save-settings';
import checkInMixin from '../../mixins/workspaces/check-in';

const __vue_script__ = {
    name: 'AssistedSessionCheckIn',

    components: {
        Accordion,
        BaseSelect,
        GenericDocExternalPicker,
        ResetSessionCheckInData,
        StringsArrayInput,
        Toggler,
    },

    mixins: [saveSettings, checkInMixin],

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            fields: [],
            eventId: this.params.event._id,
            scope: get(this.params, 'currentController.routeOptions.settingsKey'),
            ready: false,
            innerValue: {
                scan_qr_code: true,
                search: true,
                metadata_to_search_by: [],
                metadata_to_display: [],
                walk_ins: true,
                walk_ins_sessions: [],
                metadata_verification_screen: [],
                checked_in_attendees: true,
                metadata_to_display_checked_in_attendees: [],
                non_checked_in_attendees: true,
                metadata_to_display_non_checked_in_attendees: [],
            }
        };
    },

    created() {
        this.init();
    },

    methods: {
        async init(skipCache) {
            try {
                const metadata = await this.$services.metadata.getUserRegistrationFields(this.eventId, true);
                const fields = metadata
                    .filter(m => ['text', 'email', 'choice', 'choice-list', 'boolean', 'number'].includes(m.kind))
                    .map(m => ({ value: m.name, label: this.getFieldLabel(m) }));

                this.fields = fields;

                const currentSettings = await this.$services.settings.getSetting(this.eventId, this.scope, skipCache ? 0 : 5000);
                console.info('[AssistedSessionCheckIn] Settings loaded', currentSettings);

                this.innerValue = { ...this.innerValue, ...currentSettings };

                for (const field of SESSION_CHECK_IN_METADATA_FIELDS) {
                    if (currentSettings[field]) {
                        this.innerValue[field] = this.keysToMetadataFields(currentSettings[field]);
                    }
                }

                this.ready = true;
            } catch (error) {
                console.error('[AssistedSessionCheckIn] Could not load settings', error);
            }
        },

        saveSettings() {
            const valueToSave = { ...this.innerValue };
            console.info('[AssistedSessionCheckIn] Saving settings', this.scope, this.innerValue);
            return this.save(this.eventId, this.scope, valueToSave);
        },

        keysToMetadataFields(keys) {
            return keys.map(k => this.fields.find(f => f.value === k));
        },
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"assisted-session-check-in"},[_c('validation-observer',{attrs:{"slim":true},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
return [_c('form',{on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.saveSettings)}}},[_c('div',{staticClass:"panels panels-a"},[_c('div',{staticClass:"panel"},[_c('h5',[_vm._v(_vm._s(_vm.$t('assisted_check_in.intro')))]),(_vm.ready)?_c('accordion',{attrs:{"headers-i18n-prefix":"assisted_check_in.sections","unlimited-height":true},scopedSlots:_vm._u([{key:"check_in",fn:function(ref){return [_c('p',{attrs:{"slim":false}},[_vm._v(_vm._s(_vm.$t('assisted_check_in.section_intros.check_in_intro')))]),_c('validation-provider',{attrs:{"slim":true}},[_c('toggler',{attrs:{"name":"scan_qr_code","on-label":"assisted_check_in.form.scan_qr_code","off-label":"assisted_check_in.form.scan_qr_code"},model:{value:(_vm.innerValue.scan_qr_code),callback:function ($$v) {_vm.$set(_vm.innerValue, "scan_qr_code", $$v)},expression:"innerValue.scan_qr_code"}})],1),_c('validation-provider',{attrs:{"slim":true}},[_c('toggler',{attrs:{"name":"search","on-label":"assisted_check_in.form.search","off-label":"assisted_check_in.form.search"},model:{value:(_vm.innerValue.search),callback:function ($$v) {_vm.$set(_vm.innerValue, "search", $$v)},expression:"innerValue.search"}})],1),(_vm.innerValue.search)?_c('div',{staticClass:"feature-dependant"},[_c('base-select',{attrs:{"name":"metadata_to_search_by","track-by":"value","label":_vm.$t('assisted_check_in.form.metadata_to_search_by'),"options":_vm.fields,"multiple":true},model:{value:(_vm.innerValue.metadata_to_search_by),callback:function ($$v) {_vm.$set(_vm.innerValue, "metadata_to_search_by", $$v)},expression:"innerValue.metadata_to_search_by"}}),_c('base-select',{attrs:{"name":"metadata_to_display","track-by":"value","label":_vm.$t('assisted_check_in.form.metadata_to_display'),"options":_vm.fields,"multiple":true,"max":2},model:{value:(_vm.innerValue.metadata_to_display),callback:function ($$v) {_vm.$set(_vm.innerValue, "metadata_to_display", $$v)},expression:"innerValue.metadata_to_display"}})],1):_vm._e(),_c('fieldset',[_c('validation-provider',{attrs:{"slim":true}},[_c('toggler',{attrs:{"name":"walk_ins","on-label":"assisted_check_in.form.walk_ins","off-label":"assisted_check_in.form.walk_ins"},model:{value:(_vm.innerValue.walk_ins),callback:function ($$v) {_vm.$set(_vm.innerValue, "walk_ins", $$v)},expression:"innerValue.walk_ins"}})],1),(_vm.innerValue.walk_ins)?_c('div',{staticClass:"feature-dependant"},[_c('validation-provider',{attrs:{"slim":true,"rules":"required","name":_vm.$t('assisted_check_in.form.walk_ins_sessions')},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('generic-doc-external-picker',{attrs:{"event-id":_vm.eventId,"label":_vm.$t('assisted_check_in.form.walk_ins_sessions'),"fp-type":"session","placeholder":_vm.$t("assisted_check_in.form.walk_ins_sessions_placeholder"),"multiple":true,"sortable":false,"name":"session_ext_picker","filter-by":{ key: 'access_control', value: true },"allow-empty":false,"errors":errors},model:{value:(_vm.innerValue.walk_ins_sessions),callback:function ($$v) {_vm.$set(_vm.innerValue, "walk_ins_sessions", $$v)},expression:"innerValue.walk_ins_sessions"}})]}}],null,true)})],1):_vm._e()],1),_c('fieldset',[_c('base-select',{attrs:{"name":"metadata_verification_screen","track-by":"value","label":_vm.$t('assisted_check_in.form.metadata_verification_screen'),"options":_vm.fields,"multiple":true},model:{value:(_vm.innerValue.metadata_verification_screen),callback:function ($$v) {_vm.$set(_vm.innerValue, "metadata_verification_screen", $$v)},expression:"innerValue.metadata_verification_screen"}})],1)]}},{key:"dashboard",fn:function(ref){return [_c('p',{attrs:{"slim":false}},[_vm._v(_vm._s(_vm.$t('assisted_check_in.section_intros.dashboard_intro')))]),_c('validation-provider',{attrs:{"slim":true}},[_c('toggler',{attrs:{"name":"checked_in_attendees","on-label":"assisted_check_in.form.checked_in_attendees","off-label":"assisted_check_in.form.checked_in_attendees"},model:{value:(_vm.innerValue.checked_in_attendees),callback:function ($$v) {_vm.$set(_vm.innerValue, "checked_in_attendees", $$v)},expression:"innerValue.checked_in_attendees"}})],1),(_vm.innerValue.checked_in_attendees)?_c('div',{staticClass:"feature-dependant"},[_c('base-select',{attrs:{"name":"metadata_to_display_checked_in_attendees","track-by":"value","label":_vm.$t('assisted_check_in.form.metadata_to_display'),"options":_vm.fields,"multiple":true,"max":2},model:{value:(_vm.innerValue.metadata_to_display_checked_in_attendees),callback:function ($$v) {_vm.$set(_vm.innerValue, "metadata_to_display_checked_in_attendees", $$v)},expression:"innerValue.metadata_to_display_checked_in_attendees"}})],1):_vm._e(),_c('validation-provider',{attrs:{"slim":true}},[_c('toggler',{attrs:{"name":"non_checked_in_attendees","on-label":"assisted_check_in.form.non_checked_in_attendees","off-label":"assisted_check_in.form.non_checked_in_attendees"},model:{value:(_vm.innerValue.non_checked_in_attendees),callback:function ($$v) {_vm.$set(_vm.innerValue, "non_checked_in_attendees", $$v)},expression:"innerValue.non_checked_in_attendees"}})],1),(_vm.innerValue.non_checked_in_attendees)?_c('div',{staticClass:"feature-dependant"},[_c('base-select',{attrs:{"name":"metadata_to_display_checked_in_attendees","track-by":"value","label":_vm.$t('assisted_check_in.form.metadata_to_display'),"options":_vm.fields,"multiple":true,"max":2},model:{value:(_vm.innerValue.metadata_to_display_non_checked_in_attendees),callback:function ($$v) {_vm.$set(_vm.innerValue, "metadata_to_display_non_checked_in_attendees", $$v)},expression:"innerValue.metadata_to_display_non_checked_in_attendees"}})],1):_vm._e()]}}],null,true)}):_vm._e()],1),_c('div',{staticClass:"panel"},[_c('h3',[_vm._v(_vm._s(_vm.$t('assisted_check_in.actions.title')))]),_c('accordion',{attrs:{"headers-i18n-prefix":"assisted_check_in.actions"},scopedSlots:_vm._u([{key:"reset_session_check_in_data",fn:function(ref){return [_c('reset-session-check-in-data',{attrs:{"event":_vm.params.event}})]}}],null,true)})],1)]),_c('secondary-toolbar',[_c('button',{staticClass:"btn btn-primary"},[_vm._v(_vm._s(_vm.$t('general.save')))])])],1)]}}])})],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "AssistedSessionCheckIn.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__